// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/products/ProductFacetIcons.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/products/ProductFacetIcons.tsx");
  import.meta.hot.lastModified = "1748278801902.7173";
}
// REMIX HMR END

import { useTranslation } from 'react-i18next';
const ICONS = [{
  code: 'gluten',
  iconPath: '/facetIcons/gluten.png',
  id: '3',
  en: 'Gluten Free',
  cs: 'Bez lepku'
}, {
  code: 'vegan',
  iconPath: '/facetIcons/vegan.png',
  id: '4',
  en: 'Vegan',
  cs: 'Veganské'
}];
export function ProductFacetIcons({
  ids
}) {
  _s();
  const {
    i18n: {
      language
    }
  } = useTranslation();
  return <div className="flex gap-2 mt-3 min-h-8">
      {ICONS.filter(icon => ids.includes(icon.id)).map(icon => <img key={icon.code} src={icon.iconPath} width={32} height={32} alt={`${icon[language]}`} />)}
    </div>;
}
_s(ProductFacetIcons, "5+UqYoOzQHHT4HLGPwoYURDOIBQ=", false, function () {
  return [useTranslation];
});
_c = ProductFacetIcons;
var _c;
$RefreshReg$(_c, "ProductFacetIcons");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;